<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'About Us',
          to: {
            name: 'AboutUs'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'AboutUsEdit',
            query: {
              section: $route.query.section,
            }
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 About Us</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>

    <!-- block 1 -->
    <div class="block">
      <PageMenu :sections="sections">
        <component :is="sectionView" style="min-height: 800px;" :about="about"></component>
      </PageMenu>
    </div>

    <!-- page-actions -->
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';
import BrandMessaging from '@/views/A_AboutUs/c/A-2-1_AboutUsEdit_BrandMessaging.vue';
import CorporateInvestmentMessage from '@/views/A_AboutUs/c/A-2-2_AboutUsEdit_CorporateInvestmentMessaging.vue';
import PartnerEndorsement from '@/views/A_AboutUs/c/A-2-3_AboutUsEdit_PartnerEndorsement.vue';
import InvestorInformation from '@/views/A_AboutUs/c/A-2-4_AboutUsEdit_InvestorInformation.vue';
import CSR from '@/views/A_AboutUs/c/A-2-5_AboutUsEdit_CSR.vue';
import Employee from '@/views/A_AboutUs/c/A-2-6_AboutUsEdit_EmployeeInvestment&Recruiting.vue';
import VideoRotate from '@/views/A_AboutUs/c/A-2-7_AboutUsEdit_VideoRotate.vue';
import partnerSay from '@/views/A_AboutUs/c/A-2-8_AboutUsEdit_WhatOurPartnerSay.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    PageMenu,
    BrandMessaging,
    CorporateInvestmentMessage,
    PartnerEndorsement,
    InvestorInformation,
    CSR,
    Employee,
    VideoRotate,
    LangDialog,
    Breadscrumbs,
    partnerSay,
  },
  data: () => ({
    isLangOpen: false,
    sections: [
      { name: 'Brand Messaging', component: 'BrandMessaging' },
      {
        name: 'Corporate Investment Messaging',
        component: 'CorporateInvestmentMessage',
      },
      { name: 'Partner Endorsement', component: 'PartnerEndorsement' },
      { name: 'Investor Information', component: 'InvestorInformation' },
      { name: 'CSR', component: 'CSR' },
      {
        name: 'Employee Investment & Recruiting',
        component: 'Employee',
      },
      { name: 'Video Rotate', component: 'VideoRotate' },
      { name: 'What Our Partners Say', component: 'partnerSay' },
    ],
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('about', ['about']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    await this.getAbout();
  },
  methods: {
    ...mapActions('about', {
      getAbout: 'find',
      save: 'save',
      clear: 'clear',
    }),
    cancelHandler() {
      this.$router.push({ name: 'AboutUs' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.about).then(() => {
          this.$router.push({ name: 'AboutUs' });
          this.clear();
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
